"use strict";
/**
 * The applications module provides access to the applications data from the EVA back-end
 * @preferred
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./base");
var service_1 = require("../service");
var xhr_1 = require("../xhr");
/**
 * Provides access to a babylon Brands (fashion) in EVA
 */
var Brand = /** @class */ (function (_super) {
    __extends(Brand, _super);
    function Brand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Brand.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {
            ID: this.getId()
        };
        return _super.prototype.fetch.call(this, "GetBrand", requestData);
    };
    return Brand;
}(base_1.FetchableItem));
exports.Brand = Brand;
var Brands = /** @class */ (function (_super) {
    __extends(Brands, _super);
    function Brands() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Sets the current item details using the fetched service response.
     * Extending classes should override this method to pull the details from response
     * @param  {RES}        response    The response from the service call
     * @return {Array<T>}               The item details
     */
    Brands.prototype.setData = function (response) {
        // The default response is usually EVA.Core.PagedResultGeneric
        // An extending class will know exactly what is returned and where
        // the data for <T> can be found
        //
        // Store the paging response information
        //
        this.currentPageNumber = 1;
        this.totalNumberOfPages = 1;
        this.totalNumberOfItems = response.Result.length;
        this.appliedFilter = {};
        // Set and return the page items
        //
        return this.data = response.Result;
    };
    /**
     * Fetches the list of items
     * @return {Promise<IEVAServiceResponse<EVA.Core.Services.ListBrandsPaged, EVA.Core.Services.ListBrandsResponse>>} A promise resolving when the fetch from the back-end has completed
     */
    Brands.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {};
        return _super.prototype.fetch.call(this, "ListBrands", requestData);
    };
    return Brands;
}(base_1.FetchablePagedList));
exports.Brands = Brands;
function searchBrands(query, pageSize) {
    // Create the service instance
    //
    var callURL = "/api/v1/brand/search";
    var service = new service_1.EVAService("SearchBrands", callURL, xhr_1.EXMLHttpRequestMethod.POST);
    // PageSize does not appear to function
    //
    var requestData = {
        PageSize: pageSize,
        Query: query
    };
    // Perform the call and capture the resulting promise
    //
    return service.call(requestData);
}
exports.searchBrands = searchBrands;
